import React from "react";
import { Input } from "@/components/ui/input";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

// Toolbar row: full-text search, distrik filter, and toggles to show
// exhausted / expired SOs. Kept purely presentational so the parent
// keeps ownership of the filter state (used by the useMemo below it).
export default function SalesOrderFilters({
  q, onQChange,
  filterDistrik, onFilterDistrikChange,
  districts,
  showExhausted, onShowExhaustedChange,
  showExpired, onShowExpiredChange,
  hiddenCounts,
  filteredCount, totalCount,
}) {
  return (
    <div className="flex items-center justify-between mb-3 gap-3 flex-wrap">
      <div className="flex items-center gap-4 flex-wrap">
        <div className="flex items-center gap-2 flex-1 min-w-[220px]">
          <span className="overline text-xs">Cari:</span>
          <Input
            value={q}
            onChange={(e) => onQChange(e.target.value)}
            placeholder="No SO / Plant / Produk / Distrik…"
            className="rounded-lg h-9 w-64 font-mono"
            data-testid="so-search-input"
          />
          {q && (
            <button
              type="button"
              onClick={() => onQChange("")}
              className="text-xs text-muted-foreground hover:text-destructive font-mono"
              data-testid="so-search-clear"
              aria-label="Hapus pencarian"
            >
              ✕
            </button>
          )}
        </div>
        <div className="flex items-center gap-2">
          <span className="overline text-xs">Filter Distrik:</span>
          <Select value={filterDistrik} onValueChange={onFilterDistrikChange}>
            <SelectTrigger className="rounded-lg h-9 w-56" data-testid="so-filter-distrik">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="__all__">Semua SO</SelectItem>
              <SelectItem value="__none__">Tanpa distrik (universal)</SelectItem>
              {districts.map((d) => (
                <SelectItem key={d.id} value={d.id}>{d.kode} · {d.nama}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <label className="flex items-center gap-2 text-xs cursor-pointer select-none" data-testid="so-toggle-exhausted">
          <input
            type="checkbox"
            checked={showExhausted}
            onChange={(e) => onShowExhaustedChange(e.target.checked)}
            className="accent-primary"
          />
          <span>Tampilkan yang habis {hiddenCounts.exhausted > 0 && (
            <span className="font-mono text-muted-foreground">({hiddenCounts.exhausted})</span>
          )}</span>
        </label>
        <label className="flex items-center gap-2 text-xs cursor-pointer select-none" data-testid="so-toggle-expired">
          <input
            type="checkbox"
            checked={showExpired}
            onChange={(e) => onShowExpiredChange(e.target.checked)}
            className="accent-primary"
          />
          <span>Tampilkan yang expired {hiddenCounts.expired > 0 && (
            <span className="font-mono text-muted-foreground">({hiddenCounts.expired})</span>
          )}</span>
        </label>
      </div>
      <div className="text-xs text-muted-foreground font-mono" data-testid="so-count">
        {filteredCount} / {totalCount} SO
      </div>
    </div>
  );
}
